import { userSelector } from '../app/main/mainSlice'
import { useAppDispatch, useAppSelector } from '../app/store/hooks'
import { GET_MEALS_NOTES } from '../app/graphql/queries'
import { useQuery } from '@apollo/client'
import { setMealNotes, UserMealPlanDataSelector } from '../app/mealPlan/mealPlan.slice'
import { UseGetFlag } from '../app/launchDarkly'

const useFetchMealNotes = () => {
    const user = useAppSelector(userSelector)
    const dispatch = useAppDispatch()
    const mealPlanData = useAppSelector(UserMealPlanDataSelector);
    const { enableMealPlanChallenge } = UseGetFlag();

    const { loading: notesDataLoading, refetch: refetchUserNotes } = useQuery(GET_MEALS_NOTES, {
        variables: {
            meal_plan_id: mealPlanData?.meal_plan_id
        },
        // if launch darkly flag is false,
        skip: !mealPlanData?.meal_plan_id || !enableMealPlanChallenge,
        onCompleted: (data) => {
            if (data?.Meal_Notes) {
                dispatch(setMealNotes(data?.Meal_Notes))
            }
            else {
                dispatch(setMealNotes([]))
            }
        },
        onError: (err) => {
            console.error(err)
        }
    })

    const refetch = async () => {
        const data = await refetchUserNotes();
        if (data?.data?.Meal_Notes) {
            dispatch(setMealNotes(data?.data?.Meal_Notes))
        }
        else {
            dispatch(setMealNotes([]))
        }
    }

    return { notesDataLoading, refetchNotes: refetch }
}

export default useFetchMealNotes;
